import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import content from "../../includes/content";
import { getAssetURL } from "../../utils";

const PageTwo = ({ data, setPageTwo, setPageThree, setError, error }) => {
  const [userEmail, setUserEmail] = useState("");
  const emailHint = `${data.email.charAt(0)}*****@${
    data.email.substring(data.email.indexOf("@"))[1]
  }*****`;
  return (
    <Container className="main fadeIn">
      <Row>
        <Col className="text-space order-2 order-lg-1" lg={6}>
          <h3 className="d-flex justify-content-center align-items-center">
            {content.mainHeadline}
          </h3>
          <h1 className="d-flex justify-content-center align-items-center cert">
            CERTIFICATE
          </h1>

          <Form className="d-flex justify-content-center align-items-center">
            <div className="form-style  bottom-margin">
              <Image
                className="mobileWings"
                src={getAssetURL("mobile-wings.svg")}
              />
              <p className="form-title ">
                Please enter your email <br />
                to verify your identity
              </p>
              <p className="emailHint">Hint: {emailHint}</p>
              <div className="d-flex flex-column justify-content-center align-items-center ">
                <div className="email-box ">
                  <Image
                    className="image-icon"
                    src={getAssetURL("email-icon.svg")}
                  />

                  <div className="email-error-box ">
                    <input
                      className="email-input text-left"
                      type="email"
                      value={userEmail}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          if (userEmail === data.email) {
                            setPageTwo(false);
                            setPageThree(true);
                          } else {
                            setError({
                              status: true,
                              message: "Email does not match email on file",
                            });
                          }
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        setUserEmail(e.target.value);
                        setError({ status: false, message: "" });
                      }}
                    />
                    {error.status && (
                      <div className="error-text">{error.message}</div>
                    )}
                  </div>
                </div>
                <button
                  onClick={() => {
                    if (userEmail === data.email) {
                      setPageTwo(false);
                      setPageThree(true);
                    } else {
                      setError({
                        status: true,
                        message: "Email does not match email on file",
                      });
                    }
                  }}
                  className="process-button mt-3 mb-0 px-5"
                  type="button"
                >
                  Next <Image src={getAssetURL("arrow-icon.svg")} />
                </button>
              </div>
            </div>
          </Form>
        </Col>
        <Col
          className="right-col order-1 order-lg-2 d-flex m-0 p-0 justify-content-center align-items-start"
          lg={6}
        >
          <Image
            className="hide-img"
            fluid
            src={getAssetURL("mobile-sidetwo.png")}
          />
        </Col>
      </Row>
    </Container>
  );
};
export default PageTwo;
